import React from 'react';
import Ruc from '../recuperar/Ruc';
import './layout.css';
import { Switch, Route } from "react-router-dom";
import Cambiar from '../recuperar/Cambiar';

const Layout = () => {
    return (
        <div className="container">
            <div className="content-wrapper">
                <Switch>
                    <Route path="/cambiar/:acl">
                        <Cambiar />
                    </Route>
                    <Route path="/">
                        <Ruc />
                    </Route>
                </Switch>
            </div>
        </div>
    )
}

export default Layout